module.exports = __webpack_public_path__ + "252e3e1e5c8b54b10952840690c0b15b.svg";